import { InMemorySemanticModel } from "../in-memory/index.js";
export const createInMemorySemanticModel = () => {
    return new InMemorySemanticModel();
};
//# sourceMappingURL=in-memory-semantic-model.js.map